import { Link } from "react-router-dom";
import "./HerlevSeo.css";
import Seo from "../../../Seo/Seo";
import {
    webPageSchema,
    serviceSchema,
} from "../../../Seo/jsonld";
import { getRouteSeo } from "../../../Seo/routeSeo";

const SkolemadGlostrup = () => {
    const PATH = '/skolemad-glostrup'
    return (
        <>
            <Seo
                path={PATH}
                jsonLd={[
                    webPageSchema({
                        title: getRouteSeo(PATH)?.title,
                        description: getRouteSeo(PATH)?.description,
                        url: PATH,
                    }),
                    serviceSchema({
                        name: "Skolemad og Madordninger i Glostrup",
                        description: getRouteSeo(PATH)?.description,
                        url: PATH,
                        areaServed: "glostrup",
                    }),
                ]}
            />
            <main className="herlev-page remove-space">
                <section className="herlev-hero">
                    <div className="herlev-hero-shape herlev-hero-shape-one" />
                    <div className="herlev-hero-shape herlev-hero-shape-two" />
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-7">
                                <div className="herlev-hero-copy wow fadeInUp">
                                    <span className="herlev-kicker">Skolemad og Madordninger i Glostrup</span>
                                    <h1>Skolemad og Forplejning i Glostrup – Enkel Madordning til Skoler, Institutioner og Virksomheder</h1>
                                    <div className="herlev-rule"><span /><span /></div>
                                    <p className="herlev-lead">
                                        Glostrup er en kommune, der kender værdien af det praktiske og det håndgribelige. Her bor familier med børn i skolealderen, arbejder medarbejdere i virksomheder og institutioner, og handler dagligt – alle med behov for at få forplejningen til at fungere uden ukomplificeret administration.
                                    </p>
                                    <p className="herlev-lead">
                                        Onlineskolemad er udviklet for præcis denne virkelighed. Vi leverer skolemad til skoler, madordninger til institutioner, og frokostordninger til arbejdspladser i Glostrup. Uden sjusk, uden rod – blot pålidelig mad på tiden, dag efter dag.
                                    </p>
                                    <p className="herlev-lead">
                                        For skoleledere, institutionschefer, virksomhedsejere og forældre: Vi løser madordningen, så I kan fokusere på det, der betyder noget.
                                    </p>
                                    <div className="herlev-actions">
                                        <Link className="herlev-text-link" to="/contact">Få mere at vide – kontakt os uforpligtende <i className="fas fa-arrow-right" /></Link>
                                    </div>
                                    <div className="herlev-trust-row">
                                        <span><i className="fas fa-check-circle" /> Egne chauffører</span>
                                        <span><i className="fas fa-check-circle" /> Online bestilling</span>
                                        <span><i className="fas fa-check-circle" /> Halal</span>
                                    </div>
                                    <div className="flex-group play-app row">
                                        <div className="col-md-6 ">
                                            <Link className="btn btn-dark google_ply mb-3" target="blank" to={'https://apps.apple.com/dk/app/onlineskolemad/id6741146828?l=da'}>
                                                <span className="play_img">
                                                    <img src="/assets/img/apple-icon.svg" alt="not found" />
                                                </span>
                                                <div className="download-cont">
                                                    <span>Download i</span>
                                                    <p>Appstore</p>
                                                </div>
                                            </Link>
                                            <img className="qr-img" src="/assets/img/qr-ios.png" />
                                        </div>
                                        <div className="col-md-6 mt-md-0 mt-4 mb-md-0 mb-5">
                                            <Link className="btn btn-dark google_ply mb-3" target="blank" to={'http://play.google.com/store/apps/details?id=com.onlineskolemad&hl=en'}>
                                                <span className="play_img">
                                                    <img src="/assets/img/palystore-icon.svg" alt="not found" />
                                                </span>
                                                <div className="download-cont">
                                                    <span>Hent den i</span>
                                                    <p>Google Play</p>
                                                </div>
                                            </Link>
                                            <img className="qr-img" src="/assets/img/qr-android.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="herlev-hero-image wow fadeInRight">
                                    <img src="/assets/img/childrens-2.png" alt="Børn, der nyder skolemad" />
                                    <div className="herlev-hero-note"><strong>2730</strong><span>Ballerup</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="herlev-intro sec-pd">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="herlev-photo-frame wow fadeInLeft">
                                    <img src="/assets/img/food-1.png" alt="Frisk skolemad fra Onlineskolemad" />
                                    <span className="herlev-photo-stamp"><i className="fas fa-heart" /> Gør frokosten lettere</span>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="herlev-copy-block wow fadeInUp">
                                    <span className="herlev-eyebrow">Hvorfor Pålidelig Forplejning Betyder Noget I Glostrup</span>
                                    <h2>Madordning Skal Ikke Være Kompliceret</h2>
                                    <div className="herlev-rule"><span /><span /></div>
                                    <p>
                                        Glostrup er fyldt med mennesker, som har andre ting at tænke på. Skoler skal undervise, institutioner skal yde omsorgen, virksomheder skal drive forretning. Ingen har tid til at administrere madordninger, hvis det ikke er deres kerneopgave.
                                    </p>
                                    <p><strong>En dårlig madordning betyder:</strong></p>
                                    <ul>
                                        <li>Lærere og personale skal bruge tid på at håndtere logistik i stedet for deres arbejde</li>
                                        <li>Elever og brugere får mindre variation og dårligere ernæring</li>
                                        <li>Forældre skal selv tilberede madpakker hver dag</li>
                                        <li>Virksomheder skal sige nej til at tilbyde frokost til medarbejderne</li>
                                    </ul>
                                    <p><strong>En god madordning betyder:</strong></p>
                                    <ul>
                                        <li>Skole kan fokusere på undervisning; maden er håndteret</li>
                                        <li>Institutioner kan yde deres kerneopgave uden køkkenpres</li>
                                        <li>Medarbejderne får daglig frokost uden at virksomheden skal administrere det</li>
                                        <li>Forældre får ro i sindet – børnene får ordentlig ernæring</li>
                                    </ul>
                                    <p>Glostrup-mennesker værdsætter effektivitet og pålidelighed. Når noget skal fungere, skal det fungere uden dødvægt. Det er præcis hvor vi kommer ind.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="sec-pd bg-gray position-relative">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6 mmb-20">
                                <div>
                                    <div className="title-1 wow fadeInUp" data-wow-delay="0.1s">
                                        <h2>
                                            Hvad Karakteriserer Glostrup's Forplejningsbehov
                                        </h2>
                                        <div className="herlev-rule"><span /><span /></div>
                                        <p>
                                            Glostrup er både en boligkommune og en erhvervskommune. Mennesker både bor og arbejder her.
                                        </p>
                                        <p>
                                            <strong> Skoler og Børnefamilier </strong> Glostrup har grundskoler, friskoler og specialiserede læringsmiljøer. Mange familier søger løsninger, som gør hverdagen mindre stresset. En skolemadordning, som virker, fjerner daglig beslutningsbelastning fra forældrene.
                                        </p>
                                        <p>
                                            <strong>Virksomheder og Arbejdspladser</strong> Glostrup er hjemsted for mange virksomheder – fra mindre håndværker-virksomheder til større kontoroperationer. Arbejdsgivere ønsker at holde på deres medarbejdere, og en daglig frokostordning er konkret måde at vise, at man værdsætter dem.
                                        </p>
                                        <p>
                                            <strong>Institutioner Med Brugere</strong> Børnehaver, dagcentre, ældrecentre og sociale tilbud skal dagligt servicere mennesker med mad. En pålidelig madleverandør frigør ressourcer, som kan bruges på selve omsorgen.
                                        </p>
                                        <p>
                                            <strong>En Kommune Med Tempo</strong> Glostrup har en praktisk karakter. Folk vil have det løst, ikke diskuteret. Madordningen skal bare virke.
                                        </p>
                                        <p>
                                            I denne sammenhæng er en pålidelig madleverandør ikke bare godt at have – det er nødvendigt for at tingene kan fungere.
                                        </p>
                                        <div className="flex-group play-app row">
                                            <div className="col-md-6 mt-md-0 mt-4 mb-md-0 mb-5">
                                                <Link className="btn btn-dark google_ply mb-3" target="blank" to={'https://apps.apple.com/dk/app/onlineskolemad/id6741146828?l=da'}>
                                                    <span className="play_img">
                                                        <img src="/assets/img/apple-icon.svg" alt="Apple App Store" />
                                                    </span>
                                                    <div className="download-cont">
                                                        <span>Download i</span>
                                                        <p>Appstore</p>
                                                    </div>
                                                </Link>
                                                <img className="qr-img" src="/assets/img/qr-ios.png" alt="QR-kode til Onlineskolemad i App Store" />
                                            </div>
                                            <div className="col-md-6">
                                                <Link className="btn btn-dark google_ply mb-3" target="blank" to={'http://play.google.com/store/apps/details?id=com.onlineskolemad&hl=en'}>
                                                    <span className="play_img">
                                                        <img src="/assets/img/palystore-icon.svg" alt="Google Play" />
                                                    </span>
                                                    <div className="download-cont">
                                                        <span>Hent den i</span>
                                                        <p>Google Play</p>
                                                    </div>
                                                </Link>
                                                <img className="qr-img" src="/assets/img/qr-android.png" alt="QR-kode til Onlineskolemad i Google Play" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="img-style-3 pl-2per img-res-md wow fadeInRight">
                                    <img src="/assets/img/download-mobile.png" alt="Onlineskolemad-appen på en mobiltelefon" loading="lazy" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="download-banner img-res-md">
                        <img src="/assets/img/download-app.png" alt="Download Onlineskolemad-appen" loading="lazy" />
                    </div>
                </section>

                <section className="herlev-pale-section sec-pd">
                    <div className="container">
                        <div className="herlev-section-heading">
                            <span className="herlev-eyebrow">Noget for enhver frokost</span>
                            <h2>Det, Som Skiller os Fra Andre</h2>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-lg-4">
                                <article className="herlev-menu-item wow fadeInUp" data-wow-delay="0s">
                                    <span className="herlev-menu-icon"><i className="fas fa-utensils" /></span>
                                    <div><h3>Præcision I Alt Vi Gør </h3><p>Når vi lover levering klokken 11.30, kommer vi klokken 11.30. Ikke fem minutter senere. Denne præcision betyder, at skoler og institutioner kan planlægge rundt om os i stedet for at skulle være fleksible og afvente.</p></div>
                                </article>
                            </div>
                            <div className="col-md-6 col-lg-4">
                                <article className="herlev-menu-item wow fadeInUp" data-wow-delay="0s">
                                    <span className="herlev-menu-icon"><i className="fas fa-utensils" /></span>
                                    <div><h3>Vi Taler Klart Dansk, Ingen Legalese</h3><p>Der er ingen skjulte gebyrer, ingen kompleks fagterminologi, ingen "men-klausuler" som ingen forstår. Du ved hvad du betaler, hvad du får, og hvad der sker hvis noget ændrer sig.</p></div>
                                </article>
                            </div>
                            <div className="col-md-6 col-lg-4">
                                <article className="herlev-menu-item wow fadeInUp" data-wow-delay="0.08s">
                                    <span className="herlev-menu-icon"><i className="fas fa-bread-slice" /></span>
                                    <div><h3>Rigtig Ernæring Uden Konstant Debat</h3><p>Vi tilbyder balanceret mad, der både ernærer og smager godt. Vi gennemtænker menu, så der er variation uden at kvaliteten varierer.</p></div>
                                </article>
                            </div>
                            <div className="col-md-6 col-lg-4">
                                <article className="herlev-menu-item wow fadeInUp" data-wow-delay="0.16s">
                                    <span className="herlev-menu-icon"><i className="fas fa-box" /></span>
                                    <div><h3>Rimelig Fleksibilitet</h3><p>Er der en dag, hvor institutionen har mindre behov? Kan virksomheden ikke det kolde antal portioner denne uge? Vi justerer uden drama. Vi forstår at virkeligheden er flydende.</p></div>
                                </article>
                            </div>
                            <div className="col-md-6 col-lg-4">
                                <article className="herlev-menu-item wow fadeInUp" data-wow-delay="0.24s">
                                    <span className="herlev-menu-icon"><i className="fas fa-leaf" /></span>
                                    <div><h3>Du Kan Kontakte Os Direkte</h3><p>Du taler ikke til en nummerplade. Du kan ringe og tale til mennesker, som kan tage beslutninger.</p></div>
                                </article>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="herlev-audience sec-pd">
                    <div className="container">
                        <div className="row align-items-end mb-4">
                            <div className="col-lg-8">
                                <span className="herlev-eyebrow">En løsning til hverdagen</span>
                                <h2>Hvad Vi Kan Ordne For Dig</h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <article className="herlev-audience-card">
                                    <span>01</span>
                                    <h3>Skolemad – Den Enkleste Løsning for Skoler</h3>
                                    <p>Skoler i Glostrup kan få fuldt ordnet skolemad uden selv at skulle administrere det. Vi udbyder:</p>
                                    <ul className="herlev-check-list">
                                        <li>Balancerede menuer tilpasset elevernes alder og ernæringsbehov</li>
                                        <li>Levering på de tidspunkter, som passer skolens skema</li>
                                        <li>Håndtering af allergi og diætiske ønsker</li>
                                        <li>Enkel administraton for skolekøkkenet – alt er forudplanlagt</li>
                                    </ul>
                                    <p>
                                        Skolepersonalet kan fokusere på undervisning. Eleverne får deres frokost. Forældre ved, at det er løst.
                                    </p>
                                    <Link to="/contact">Læs mere om vores skolemad-ordninger <i className="fas fa-arrow-right" /></Link>
                                </article>
                            </div>
                            <div className="col-md-4">
                                <article className="herlev-audience-card">
                                    <span>02</span>
                                    <h3>Kantineordning til Institutioner</h3>
                                    <p>nstitutioner – plejecentre, dagcentre, ungdomsklubber, sociale tilbud – kan få deres daglige madtilberedning håndteret af os.</p>
                                    <ul className="herlev-check-list">
                                        <li>Ernæring tilpasset brugergruppen</li>
                                        <li>Fast leveringsplan eller fleksibel tilpasning efter behov</li>
                                        <li>Institutionen fokuserer på omsorgen, ikke køkkendriften</li>
                                        <li>Gennemsigtig prisfastsættelse</li>
                                    </ul>
                                    <Link to="/contact">Se hvordan institutioner profiterer af kantineordning<i className="fas fa-arrow-right" /></Link>
                                </article>
                            </div>
                            <div className="col-md-4">
                                <article className="herlev-audience-card">
                                    <span>03</span>
                                    <h3>Frokost til Virksomheder og Arbejdspladser</h3>
                                    <p>Virksomheder i Glostrup kan tilbyde deres medarbejdere frokost uden selv at skulle administrere det.</p>
                                    <ul className="herlev-check-list">
                                        <li>Enkel bestilling og fakturering</li>
                                        <li>Fleksibilitet – medarbejdere kan melde sig på eller fra dag-til-dag</li>
                                        <li>Høj medarbejdertilfredshed</li>
                                        <li>Virksomheden slipper helt for administrationen</li>
                                    </ul>
                                    <Link to="/contact">Udforsk virksomhedsfrokost <i className="fas fa-arrow-right" /></Link>
                                </article>
                            </div>
                            <div className="col-md-4">
                                <article className="herlev-audience-card">
                                    <span>04</span>
                                    <h3>Catering til Møder, Arrangementer og Events</h3>
                                    <p>Når Glostrup-virksomheder, skoler eller organisationer skal holde møde eller arrangement, kan vi levere catering.</p>
                                    <ul className="herlev-check-list">
                                        <li>Skræddersyede menuer</li>
                                        <li>Professionel opsætning og præsentation</li>
                                        <li>Fleksibel antal portioner</li>
                                        <li>Både småkostioner og fulde måltider</li>
                                    </ul>
                                    <Link to="/contact">vide mere <i className="fas fa-arrow-right" /></Link>
                                </article>
                            </div>
                            <div className="col-md-4">
                                <article className="herlev-audience-card">
                                    <span>05</span>
                                    <h3>Fleksibel Madlevering til Mindre Ordrer</h3>
                                    <p>Ud over faste ordninger kan du også få mad leveret til engangstilfælde – en større mødedag, en klassefest, eller når institutionen har særligt behov.</p>
                                    <Link to="/contact">vide mere <i className="fas fa-arrow-right" /></Link>
                                </article>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="herlev-situation-section sec-pd">
                    <div className="container">
                        <div className="herlev-section-heading">
                            <span className="herlev-eyebrow">Madordninger til forskellige behov</span>
                            <h2>Forskellige Behov, Forskellige Løsninger</h2>
                            <div className="herlev-rule"><span /><span /></div>
                            <p>Ikke alle søger det samme. Her er hvordan forskellige institutioner og virksomheder i Glostrup kan få gavn af vores tilbud:</p>
                        </div>
                        <div className="herlev-situation-table-wrap">
                            <table className="herlev-situation-table">
                                <thead>
                                    <tr>
                                        <th scope="col">Institution/Virksomhed</th>
                                        <th scope="col">Tilbud</th>
                                        <th scope="col">Konkret Fordel</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td data-label="Situation">Grundskole med 250 elever</td>
                                        <td data-label="Passende løsning"><strong>Daglig skolemad</strong></td>
                                        <td data-label="Hvorfor">Skole sparer administrativ arbejde, elever får varieret mad, køkkenpersonale frigøres</td>
                                    </tr>
                                    <tr>
                                        <td data-label="Situation">Industri-virksomhed med 80 ansatte</td>
                                        <td data-label="Passende løsning"><strong>Regelmæssig frokostordning</strong></td>
                                        <td data-label="Hvorfor">Medarbejderne får frokost uden virksomheden skal administrere det; medarbejdertilfredshed stiger</td>
                                    </tr>
                                    <tr>
                                        <td data-label="Situation">Plejecenter med 100 beboere</td>
                                        <td data-label="Passende løsning"><strong>Fast kantineordning</strong></td>
                                        <td data-label="Hvorfor">Ernæring sikres, institutionen slipper for køkkendrift, mere tid til omsorg</td>
                                    </tr>
                                    <tr>
                                        <td data-label="Situation">Mindre kontor-arbejdsplads</td>
                                        <td data-label="Passende løsning"><strong>Fleksibel frokost pr. bestilling</strong></td>
                                        <td data-label="Hvorfor">Nem administraton, medarbejdere kan melde sig på eller fra, ingen uødvendig affald</td>
                                    </tr>
                                    <tr>
                                        <td data-label="Situation">Børnehave</td>
                                        <td data-label="Passende løsning"><strong>Snacks og lette måltider</strong></td>
                                        <td data-label="Hvorfor">Tilpasset små børn, allergi-sikkerhed, daglig variation</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <p className="herlev-situation-note mt-1">Denne tabel hjælper dig hurtigt at se, om vi har en løsning til dig. Hvis dine behov ikke helt passer ind, kontakt os alligevel – vi finder ofte på noget.</p>
                    </div>
                </section>

                <section className="herlev-steps sec-pd">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-5">
                                <div className="herlev-copy-block">
                                    <h2>Fra Første Tanke til Daglig Madlevering</h2>
                                    <div className="herlev-rule"><span /><span /></div>
                                    <Link className="btn btn-1" to="/signup">Opret bruger</Link>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="herlev-step-list">
                                    <div className="herlev-step">
                                        <span>01</span>
                                        <div>
                                            <h3>Du Napper Telefonen </h3>
                                            <p>Ring eller skriv til os. Du behøver kun sige hvad du har brug for. "Vi er en skolekantine med 300 elever," eller "Vi leder efter frokost til 40 medarbejdere," eller "Vi skal have catering til 150 gæster på næste torsdag."</p>
                                        </div>
                                    </div>
                                    <div className="herlev-step">
                                        <span>02</span>
                                        <div>
                                            <h3>Vi Drøfter Detaljer </h3>
                                            <p>Vi stiller spørgsmål som betyder noget: Hvilke dage? Hvilke tider? Er der allergi eller ønsker vi skal kende til? Hvor skal det leveres? Hvad er dit budget-område?</p>
                                        </div>
                                    </div>
                                    <div className="herlev-step">
                                        <span>03</span>
                                        <div>
                                            <h3>Vi Forslår Konkret </h3>
                                            <p>Vi kommer med et konkret forslag: Menuer, antal portioner, pris, start-dato. Ingenting er skrevet i sten – du kan bede om ændringer.</p>
                                        </div>
                                    </div>
                                    <div className="herlev-step">
                                        <span>04</span>
                                        <div>
                                            <h3>Aftale og Opstart </h3>
                                            <p>Når du godkender, sender vi en enkel aftale. Ingenting juridisk uforståeligt. Fra start-datoen leverer vi som aftalt.</p>
                                        </div>
                                    </div>
                                    <div className="herlev-step">
                                        <span>05</span>
                                        <div>
                                            <h3>Du Bruger Det, Vi Leverer </h3>
                                            <p>Skole får skolemaden dagligt. Virksomhed kan bestille via vores system. Institution ved hvornår leveringen kommer.</p>
                                        </div>
                                    </div>
                                    <div className="herlev-step">
                                        <span>06</span>
                                        <div>
                                            <h3>Løbende Tilpasning </h3>
                                            <p>Hvis det skal justeres – færre portioner, andre menuer, nye allergi-notater – kontakter du os. Vi løser det.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p>Det hele skal være lige så simpelt som processen lyder.</p>
                        </div>
                    </div>
                </section>

                <section className="herlev-reasons sec-pd">
                    <div className="container">
                        <div className="herlev-reasons-heading">
                            <div>
                                <span className="herlev-eyebrow">Det Gør os til dit Naturlige Valg i glostrup</span>
                                <h2>Madlevering I Glostrup – Sådan Arbejder Vi Lokalt</h2>
                                <p>Vi leverer til hele Glostrup. Uanset om du er på den nordlige side tæt ved motorvejen, eller sydligt op mod de etablerede boligkvarterer – vi når dig.</p>
                            </div>
                        </div>
                        <div className="herlev-reasons-grid">
                            <article className="herlev-reason-card">
                                <div className="herlev-reason-number">01</div>
                                <div className="herlev-reason-icon"><i className="fas fa-school" /></div>
                                <div>
                                    <h3>For Skoler i Glostrup:</h3>
                                    <p>Vi koordinerer med skolens undervisningsplan. Maden ankommer når skoledagen skal starte, til skolekøkkenet eller direkte til spisesteder. Hvis skolen har særlige behov omkring tider eller præsentation, løser vi det.</p>
                                </div>
                            </article>
                            <article className="herlev-reason-card">
                                <div className="herlev-reason-number">02</div>
                                <div className="herlev-reason-icon"><i className="fas fa-utensils" /></div>
                                <div>
                                    <h3>For Institutioner:</h3>
                                    <p>Dagcentre, ældrecentre, børnehaver og sociale tilbud får maden leveret på tidspunkter, der passer til deres daglige rutiner. En børnehave kan få leveret omkring formiddags-snack, et plejecenter kan have flere leveringer hvis det passer bedre til deres planlægning.</p>
                                </div>
                            </article>
                            <article className="herlev-reason-card">
                                <div className="herlev-reason-number">03</div>
                                <div className="herlev-reason-icon"><i className="fas fa-mobile-alt" /></div>
                                <div>
                                    <h3>For Virksomheder:</h3>
                                    <p>Mad kommer til arbejdspladsens adresse. Du bestemmer hvilke tider, og vi tilpasser vores logistik derefter.</p>
                                </div>
                            </article>
                            <article className="herlev-reason-card">
                                <div className="herlev-reason-number">04</div>
                                <div className="herlev-reason-icon"><i className="fas fa-leaf" /></div>
                                <div>
                                    <h3>For Arrangementer:</h3>
                                    <p>Vi aftalter præcis tidspunkt og sted for levering på dagen.
                                        Hvis du er usikker på, om vi kan nå dit område, er det enkelt at høre – kontakt os og vi siger det direkte.
                                    </p>
                                </div>
                            </article>
                        </div>
                    </div>
                </section>

                <section className="sec-pd rel-z-1">
                    <div className="top-bottom-shaps">
                        <span className="shap shap-1" />
                        <span className="shap shap-2" />
                    </div>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6 mmb-20">
                                <div className="img-style-1 wow fadeInLeft">
                                    <img src="/assets/img/about-1.png" alt="Not found" />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div>
                                    <div
                                        className="title-1 wow fadeInRight"
                                        data-wow-delay="0.1s"
                                        style={{
                                            visibility: "visible",
                                            animationDelay: "0.1s",
                                            animationName: "fadeInUp",
                                        }}
                                    >
                                        <h1>Vores Tilgang til God Skolemad</h1>
                                        <div className="herlev-rule"><span /><span /></div>
                                        <p>
                                        </p>
                                        <div className="mt-3">
                                            <p>
                                                Onlineskolemad er ikke oprettet på en eller anden idealistisk grund. Vi blev oprettet fordi skoler, institutioner og virksomheder har behov for præcis denne service. Folk søgte og spurgte – og vi lavede en løsning der virker.
                                            </p>
                                            <p>
                                                Vi bygger på:
                                            </p>
                                            <ol>
                                                <li> <strong> Praktisk realisme – </strong> vi forstår at hverdagen er kaotisk, og løsningen skal håndtere det</li>
                                                <li> <strong> Transparens – </strong> du skal aldrig være i tvivl om hvad der sker</li>
                                                <li> <strong> Kvalitet som udgangspunkt – </strong> vi skærer ikke ned på ingredienser eller tilberedning</li>
                                                <li> <strong> Lokal forankring – </strong> vi er ikke en usynlig online-service, du kan ringe til os</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="herlev-faq sec-pd">
                    <div className="container">
                        <div className="herlev-section-heading"><span className="herlev-eyebrow">Spørgsmål og svar</span><h2>Ofte Stillede Spørgsmål Om Madordninger I Glostrup</h2></div>
                        <div className="herlev-faq-list">
                            <details open>
                                <summary>Kan vores skole i Glostrup få skolemad leveret hver dag?<i className="fas fa-plus" /></summary>
                                <p>Ja. Vi leverer daglig skolemad til skoler i Glostrup. Du bestemmer hvilke dage, hvilken tidspunkt, og hvor maden skal leveres. Det kan være til køkkenet, til kantinen, eller til en anden lokation på skolens område.</p>
                            </details>
                            <details>
                                <summary>Hvad hvis nogle børn har allergi?<i className="fas fa-plus" /></summary>
                                <p>Vi tager allergi alvorligt. Du fortæller os alle allergi og ønsker, vi noterer dem i vores system, og de håndteres hver gang. Hvis der er peanut-allergi, får det barn ikke peanuts. Simpelt.</p>
                            </details>
                            <details>
                                <summary>Hvordan virker bestilling når ordningen kører?<i className="fas fa-plus" /></summary>
                                <p>Du får adgang til vores bestillingssystem. Du logger ind, ser hvilke menuer der er denne uge, og bekræfter antallet af portioner. Du kan ændre antal med kort varsel hvis der er elever væk. Hele processen tager få minutter.</p>
                            </details>
                            <details>
                                <summary>Kan en virksomhed få frokost leveret uden at alle medarbejdere skal deltage?<i className="fas fa-plus" /></summary>
                                <p>Ja. Nogle virksomheder laver fast ordning hvor alle automatisk får frokost. Andre laver fleksible ordninger hvor medarbejdere kan melde sig på eller fra dag-til-dag. Vi tilbyder begge modeller.</p>
                            </details>
                            <details>
                                <summary>Hvad hvis vi skal ændre antallet af portioner fra dag til dag?<i className="fas fa-plus" /></summary>
                                <p>Kontakt os – vi justerer normalt uden problemer. Skal skolen have 300 portioner en dag og 250 næste dag? Kan løses. Virksomheden varsler mandag morgen at I skal have færre portioner? OK.</p>
                            </details>
                            <details>
                                <summary>Hvor hurtigt kan vi starte?<i className="fas fa-plus" /></summary>
                                <p>Hvis I ringer i dag, kan vi ofte mødes denne uge. Aftalen kan være på plads i løbet af få dage. Start-dato kan variere – nogle gange kan vi starte immediately, andre gange skal vi planlægge 2-3 uger frem.</p>
                            </details>
                            <details>
                                <summary>Hvad koster det?<i className="fas fa-plus" /></summary>
                                <p>Priserne afhænger helt af hvad I har brug for – antal portioner, type mad, hyppighed, eventuelle tilpasninger. Vi giver konkrete tilbud efter at have forstået behovet. Der er ingen skjulte omkostninger eller surprise-fakturaer.</p>
                            </details>
                            <details>
                                <summary>Tilbyder I også catering til større arrangementer i Glostrup?<i className="fas fa-plus" /></summary>
                                <p>Ja. Vi laver catering til møder, fester, seminarer og særlige begivenheder. Du fortæller antallet af gæster og hvilken slags mad du ønsker, og vi laver et forslag.</p>
                            </details>
                            <details>
                                <summary>Kan institutioner også få ordnet deres daglige frokost?<i className="fas fa-plus" /></summary>
                                <p>Ja. Børnehaver, dagcentre, ældrecentre og andre institutioner kan få fast ordning på snacks, frokost, eller hele måltider – afhængigt af hvad institutionen har brug for.</p>
                            </details>
                        </div>
                    </div>
                </section>

                <section className="herlev-cta">
                    <div className="container">
                        <div className="herlev-cta-inner"><div>
                            <span className="herlev-eyebrow">Lokalt forankret i Glostrup</span>
                            <h2>Lad os Løse Madordningen For Dig</h2>
                            <p>Glostrup fortjener pålidelig forplejning, som virker. Du fortjener at kunne fokusere på det, som er dit ansvar – ikke på at administrere madordninger.</p>
                            <p>Ring til os. Skriv til os. Fortæl hvad du har brug for.</p>
                            <br />
                            <p>Vi giver gerne et konkret svar uden forpligtelser.</p>
                        </div>
                            <div className="herlev-cta-actions">
                                <Link className="btn btn-1" to="/contact">Kontakt Onlineskolemad</Link>
                                <a href="tel:26227469">Telefon: 26 22 74 69</a>
                                <a href="/">Adresse: Herlev Bygade 27, 2730 Herlev</a>
                                <a href="/">E-mail: onlineskolemad@hotmail.com</a>
                            </div>
                        </div>
                    </div>
                </section>
            </main >
        </>
    )
}

export default SkolemadGlostrup